import React from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { debouncedApiCall } from '../../../utils/app.utils';
import StateComponents from '../../../components/state-component/StateComponents';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import ManageState from './manageState';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ContainerButton from '../../../components/button/ContainerButton';

export default function StudentRegistration() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate()
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        setKeyword,
        
        handleSubmit,
        degree,
        faculty,
        id_degree,
        set_id_degree,
        id_faculty,
        set_id_faculty,
      

    } = ManageState()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("STUDENT_REGISTRATION")}
                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        placeholder: t("STUDENT_REGISTRATION_SEARCH_NAME"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                 {
                                    seq: 2,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_degree(e.target.value)
                                        },
                                        options: [{
                                            label: t('STUDENT_REGISTRATION_ALL_LEVELS'),
                                            value: "ALL",
                                        }, ...degree?.map((item: any) => {
                                            return {
                                                label: i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name,
                                                value: item?.id_degree,
                                            }
                                        })],
                                        selectId: "",
                                        value: id_degree || '',
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_faculty(e.target.value)
                                        },
                                        options: [{
                                            label: t('STUDENT_REGISTRATION_ALL_COURSES'),
                                            value: "ALL",
                                        }, ...faculty?.map((item: any) => {
                                            return {
                                                label: i18n.language === "en" ? (item?.faculty_name_eng || item?.faculty_name) : item?.faculty_name,
                                                value: item?.id_faculty,
                                            }
                                        })],
                                        selectId: "",
                                        value: id_faculty || '',
                                    }
                                },
                               

                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={2540}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                // {
                                //     seq: 1,
                                //     buttonProps: {
                                //         onClick: () => { },
                                //     },
                                //     key: "CANCEL",
                                //     label: "ย้อนกลับ",
                                //     type: "CANCEL"
                                // },
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()

                                        }
                                    },
                                    key: "SEND",
                                    label: t("STUDENT_REGISTRATION_CONFIRM"),
                                    type: 'SAVE'
                                },

                            ]}
                        />
                    </div>
                }
            />

        </div>
    )
}
